/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { ExportCaseCorrectionResponseJson } from './export-case-correction-response-json';
import { ExportCaseCorrectionResult } from '../results/export-case-correction-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class ExportCaseCorrectionResponse extends ResponseWithErrorGeneric<ExportCaseCorrectionResponseJson, ExportCaseCorrectionResult> implements IResponseWithErrorGeneric<ExportCaseCorrectionResult> {


  //<custom-body>
  constructor(response: HttpResponse<ExportCaseCorrectionResponse>) {
    super(response, ExportCaseCorrectionResult.Error);
  }
  //</custom-body>
}
